import React from 'react';
import styled from 'styled-components';
import { Tag } from 'antd';
import { theme } from 'utils/style/theme';

/**
 *
 * @returns {등록된 파일명 보여주기 태그}
 */

interface IProps {
  text?: string;
  onClose: () => void;
}
const CurrentTextTag: React.FC<IProps> = ({ text, onClose }): JSX.Element => {
  return (
    <StyledTag closable onClose={onClose}>
      <h6>첨부 파일명</h6>
      <p className='p_name'>{text}</p>
    </StyledTag>
  );
};

export default CurrentTextTag;

const StyledTag = styled(Tag)`
  padding: 0.6rem 1.5rem;
  width: 100%;
  text-align: center;
  background-color: ${theme.colors.gray_4};
  border: none;
  border-radius: 14px;
  font-size: 14px;
  position: relative;

  h6 {
    text-align: left;
    font-size: 0.9rem;
    color: ${theme.colors.gray_3};
  }
  .anticon[tabindex] {
    position: absolute;
    top: 1rem;
    right: 1.5rem;
  }
  .p_name {
    font-size: 1rem;
    color: ${theme.colors.gray_2};
    font-weight: 600;
  }
`;
